import { render, staticRenderFns } from "./LifeMeaningExplain.vue?vue&type=template&id=4192985b&scoped=true&"
import script from "./LifeMeaningExplain.vue?vue&type=script&lang=js&"
export * from "./LifeMeaningExplain.vue?vue&type=script&lang=js&"
import style0 from "./LifeMeaningExplain.vue?vue&type=style&index=0&id=4192985b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4192985b",
  null
  
)

export default component.exports